module.exports = __webpack_public_path__ + "static/img/1.ab328c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/1.png
// module id = zFd/
// module chunks = 0